module.exports = __webpack_public_path__ + "img/y-243.d7817f99.png";